import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import {
  FooterContainer,
  FooterContent,
  FooterBrand,
  FooterPrompt,
  FooterColumn,
  FooterLink,
  FooterBottom,
} from '../styles';

interface FooterProps {
  themeName: ThemeType;
  onScrollToSection: (id: string) => void;
}

const Footer: React.FC<FooterProps> = ({ themeName, onScrollToSection }) => {
  const { t } = useTranslation();

  const navItems = [
    { id: 'about', label: t('ClassicPage.nav.about') },
    { id: 'skills', label: t('ClassicPage.nav.skills') },
    { id: 'experience', label: t('ClassicPage.nav.experience') },
    { id: 'projects', label: t('ClassicPage.nav.projects') },
    { id: 'education', label: t('ClassicPage.nav.education') },
  ];

  return (
    <FooterContainer $themeName={themeName}>
      <FooterContent>
        <FooterBrand $themeName={themeName}>
          <h3>Anıl Orhan</h3>
          <p>{t('ClassicPage.tagline')}</p>
          <FooterPrompt $themeName={themeName}>$ echo "let's connect"</FooterPrompt>
        </FooterBrand>
        <FooterColumn $themeName={themeName}>
          <h4>{t('ClassicPage.nav.about') === 'About' ? 'Quick Links' : 'Hızlı Linkler'}</h4>
          {navItems.map(item => (
            <FooterLink
              key={item.id}
              $themeName={themeName}
              href={`#${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                onScrollToSection(item.id);
              }}
            >
              {item.label}
            </FooterLink>
          ))}
        </FooterColumn>
        <FooterColumn $themeName={themeName}>
          <h4>{t('ClassicPage.nav.about') === 'About' ? 'Connect' : 'Bağlantı'}</h4>
          <FooterLink $themeName={themeName} href="https://github.com/Anil-Orhan" target="_blank" rel="noopener noreferrer">
            GitHub
          </FooterLink>
          <FooterLink $themeName={themeName} href="https://www.linkedin.com/in/anılorhan/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </FooterLink>
          <FooterLink $themeName={themeName} href="https://twitter.com/anilorhandev" target="_blank" rel="noopener noreferrer">
            Twitter
          </FooterLink>
        </FooterColumn>
      </FooterContent>
      <FooterBottom $themeName={themeName}>
        {t('ClassicPage.footer.text')}
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
